function checkCookie() {
    document.cookie = 'testcookie';
    const cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    return cookieEnabled;
}

/**
 * Will return true when url has ?newsletter=1
 */
function popNewsletterUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const param = urlParams.get('no_newsletter');
    if (param) {
        return true;
    }
    return false;
}

/**
 * Set cookie
 */
function setPopupCookie(cname) {
    const d = new Date();
    const expiresInDays = 7; // Expiry in days
    const cvalue = '1'; // Value but not important
    d.setTime(d.getTime() + (expiresInDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires}`;
}

document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('.custom-form')) { // only fire popup if there is no custom-form present
        const cname = 'qm_modal_auto'; // QT Cookie name
        const csdnname = 'qm_sdn_modal_auto'; // SDN Cookie name
        if (popNewsletterUrl()) {
            // Do not show but set a cookie
            window.setPopupCookie(cname);
            window.setPopupCookie(csdnname);
        } else {
            setTimeout(
                () => {
                    if (checkCookie()) {
                        // QT Newsletter
                        if (
                            Object.prototype.hasOwnProperty.call(window, 'MicroModal')
                            && Object.prototype.hasOwnProperty.call(window, 'qm_show_modal')
                            && window.qm_show_modal
                            && document.cookie.indexOf(cname) === -1
                        ) {
                            if (!document.querySelector('.modal.is-open')) { // dont open if any modal is already open
                                window.MicroModal.show('modal-auto', window.MicroModalConfig);

                                window.setPopupCookie(cname); // Set a cookie

                                // Send to GTM / GA
                                window.dataLayer = window.dataLayer || [];
                                dataLayer.push({
                                    event: 'popup_show',
                                    newsletter: 'QT',
                                    source: 'auto',
                                });
                            }
                        }

                        // SDN Newsletter
                        if (
                            Object.prototype.hasOwnProperty.call(window, 'MicroModal')
                            && Object.prototype.hasOwnProperty.call(window, 'qm_show_sdn_modal')
                            && window.qm_show_sdn_modal
                            && document.cookie.indexOf(csdnname) === -1
                        ) {
                            if (!document.querySelector('.modal.is-open')) { // dont open if any modal is already open
                                window.MicroModal.show('modal-auto', window.MicroModalConfig);
                                window.setPopupCookie(csdnname); // Set a cookie

                                // Send to GTM / GA
                                window.dataLayer = window.dataLayer || [];
                                dataLayer.push({
                                    event: 'popup_show',
                                    newsletter: 'SDN',
                                    source: 'auto',
                                });
                            }
                        }
                    }
                },
                7000, // Seven seconds until popup
            );
        }
    }
});
